'use strict';

angular.module('mobile-apps').controller('ChangelogController', [
	'$scope','$rootScope', '$modalInstance', '$state', '$stateParams', 'loadData', 'EntryMain',
	function (
		$scope,
		$rootScope,
		$modalInstance,
		$state,
		$stateParams,
		loadData,
		EntryMain
	) {

		$scope.changeLogQuery = {};

		/**
		 * Gets called when the query gets changed in the directive
	     */
		$scope.queryChangeCallback  = function (newQuery, additionalData) {
			if (newQuery.hasOwnProperty('userId')) {
				$scope.cbUserId = newQuery.userId;
				$scope.cbUserName = additionalData.userName;
				$scope.changelogData = undefined;
				$scope.lastLogDate = null;
				$scope.initChangelog();
			}
		};


		/**
		 * Initializes the change log. Sets the query and the title
		 */
		$scope.initChangelog  = function () {

			if (loadData !== undefined) {
				// Data about what to display is given
				$scope.clTitle = loadData.headline;
				$scope.changeLogQuery = loadData.query;
			} else {
				// Figure out what to display via url
				if($scope.cbUserId) {
					$scope.changeLogQuery.userId = $scope.cbUserId;
					if ($scope.cbUserName) {
						$scope.clTitle = 'for User: ' + $scope.cbUserName;
					}
				} else {
					$scope.clTitle = 'for App';
				}
			}
		};


		$scope.ok = function(e) {
			$modalInstance.close();
			e.stopPropagation();
		};


		$scope.cancel = function(e) {
			$modalInstance.dismiss();
			e.stopPropagation();
		};
	}
]);
